module.exports = __webpack_public_path__ + "static/JWC_news-opening-a0ed5cd35cc960429e9eaf732f36d72d.jpg";